import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import buildBurnKey from 'loyalty/lib/pointsCalculation/buildBurnKey'

type BurnBatchOperation = paths['/api/lux-loyalty/points/calculate-burn/batch']['post']
type BurnBatchPayload = BurnBatchOperation['requestBody']['content']['application/json']
type BurnBatchResponse = BurnBatchOperation['responses'][200]['content']['application/json']

const BATCH_LIMIT = 100

export interface BurnBatchRequest {
  price: number
  loyaltyProductType: App.LoyaltyProductType
  mx?: string
}

export interface BurnBatchCalculationOptions {
  customerId: string
  currency: string
}

export async function requestLoyaltyPointsBurnCalculationBatch(
  requests: Array<BurnBatchRequest>,
  options: BurnBatchCalculationOptions,
): Promise<Record<string, App.LoyaltyPointsBurnBatchItem>> {
  const { customerId, currency } = options

  const chunks: Array<Array<BurnBatchRequest>> = []
  for (let i = 0; i < requests.length; i += BATCH_LIMIT) {
    chunks.push(requests.slice(i, i + BATCH_LIMIT))
  }

  const chunkResponses = await Promise.all(
    chunks.map(chunk => {
      const payload: BurnBatchPayload = {
        items: chunk.map(req => ({
          key: buildBurnKey(req, customerId),
          price: req.price,
          currency,
          loyaltyProductType: req.loyaltyProductType,
          mx: req.mx,
        })),
      }
      return requestUtils.post<BurnBatchResponse, BurnBatchPayload>(
        '/api/lux-loyalty/points/calculate-burn/batch',
        payload,
        { credentials: 'include' },
      )
    }),
  )

  const results: Record<string, App.LoyaltyPointsBurnBatchItem> = {}
  for (const response of chunkResponses) {
    for (const item of response.result.results) {
      if (item.status === 'success' && item.result.priceInPoints !== undefined) {
        results[item.key] = {
          calculationKey: item.key,
          priceInPoints: item.result.priceInPoints,
          isRedeemableWithPoints: item.result.isRedeemableWithPoints,
        }
      }
    }
  }

  return results
}
